import React, { useEffect, useRef } from "react";
import { Sparkles, Award, Heart, Users } from "lucide-react";
import "../styles/about.css";
import { useTranslation } from "react-i18next";
import aboutUs from "../images/about-us.png";
interface AboutUsPageProps {
  className?: string;
  heroImage?: string;
}

const AboutUsPage: React.FC<AboutUsPageProps> = ({
  className = "",
  heroImage = aboutUs,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const featuresRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.1 },
    );

    if (contentRef.current) observer.observe(contentRef.current);
    if (featuresRef.current) observer.observe(featuresRef.current);

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: <Sparkles className="w-8 h-8" />,
      title: t("Premium Quality"),
      description: t("We blend high-quality fabrics with refined design"),
      color: "from-blue-500 to-blue-600",
    },
    {
      icon: <Award className="w-8 h-8" />,
      title: t("Qatari Heritage"),
      description: t(
        "Drawing inspiration from Qatari heritage with contemporary spirit",
      ),
      color: "from-purple-500 to-purple-600",
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: t("Craftsmanship"),
      description: t(
        "Committed to offering products that reflect identity and distinction",
      ),
      color: "from-pink-500 to-pink-600",
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: t("Customer Focus"),
      description: t("Meeting expectations for quality and distinction"),
      color: "from-amber-500 to-amber-600",
    },
  ];

  return (
    <div className={`min-h-screen bg-[#f2e6db] ${className}`}>
      <div className="pt-10 h-48 py-2 sm:h-96 overflow-hidden flex items-center justify-center mx-4">
        {/* Overlay */}
        <img
          src={aboutUs}
          alt="About Us"
          className="w-full h-48 object-cover sm:w-auto sm:h-auto transition-transform bg-[#0d223f] duration-500 group-hover:scale-110"
        />
      </div>

      {/* Main Content Section */}
      <div className="max-w-6xl mx-auto px-6 md:pt-10 pb-10 pt-5">
        <div
          ref={contentRef}
          className="opacity-0 transform translate-y-8 transition-all duration-700"
        >
          {/* First Paragraph */}
          <div className="glass-effect-card rounded-3xl p-8 md:p-12 mb-8 transition-all duration-300 transform hover:scale-[1.02]">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-1 bg-gradient-to-r from-[#3d5a7a] to-[#5a7a9a] rounded-full mt-3"></div>
            </div>
            <p className="text-gray-800 text-lg md:text-xl leading-relaxed text-center">
              {t("about_us_title1")}
            </p>
          </div>

          {/* Second Paragraph */}
          <div className="glass-effect-card rounded-3xl p-8 md:p-12 transition-all duration-300 transform hover:scale-[1.02]">
            <div className="flex items-start justify-end gap-4 mb-6">
              <div className="w-12 h-1 bg-white rounded-full mt-3"></div>
            </div>
            <p className="text-lg md:text-xl leading-relaxed text-center opacity-90">
              {t("about_us_title2")}
            </p>
          </div>
        </div>

        {/* Features Grid */}
        {/* <div
          ref={featuresRef}
          className="opacity-0 transform translate-y-8 transition-all duration-700 mt-10 md:mt-20 pb-10"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12">
            {t("Our Values")}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {features.map((feature, index) => (
              <div
                key={index}
                className="group bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:-translate-y-2"
                style={{
                  animationDelay: `${index * 0.1}s`,
                }}
              >
                <div
                  className={`w-16 h-16 bg-gradient-to-br ${feature.color} rounded-2xl flex items-center justify-center mb-4 group-hover:rotate-12 transition-transform duration-300 shadow-lg`}
                >
                  <div className="text-white">{feature.icon}</div>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">
                  {t(feature.title)}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {t(feature.description)}
                </p>
              </div>
            ))}
          </div>
        </div> */}

        {/* Brand Statement
        <div className="mt-20 text-center">
          <div className="inline-block bg-gradient-to-r from-[#3d5a7a] to-[#5a7a9a] text-white rounded-full px-8 py-4 shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105">
            <p className="text-lg font-semibold">
              {t("Tradition meets modernity in every thread")}
            </p>
          </div>
        </div> */}

        {/* Decorative Pattern */}
        {/* <div className="mt-20 flex justify-center">
          <div className="flex gap-2"> */}
        {/* <ProductRating product={product} disabled /> */}
        {/* {[...Array(5)].map((_, i) => (
              <div
                key={i}
                className="w-3 h-3 bg-[#3d5a7a] rounded-full animate-bounce"
                style={{
                  animationDelay: `${i * 0.1}s`,
                  animationDuration: "1s",
                }}
              ></div>
            ))} */}
        {/* </div>
        </div> */}
      </div>
    </div>
  );
};

export default AboutUsPage;
